import React from 'react';
import InstituteManagementPage from './InstituteManagementPage';

const RRSManagementPage = () => {
  return (
    <InstituteManagementPage 
      instituteType="rrs"
      instituteName="Regional Research Station (RRS), Malda"
    />
  );
};

export default RRSManagementPage;
